import React from 'react'

import computer from '../../../assets/computer-with-checklist.svg'

import AreaRoles from '../../containers/AreaRoles'
import AreaRolesForm, { RoleForm, RolePreview } from '../../components/AreaRolesForm'
import Card from '../../components/Card'
import SkeletonRolePreview from '../../skeletons/SkeletonRolePreview'

const AreaRolesScene = () => (
  <AreaRoles>
    {container => (
      <Card title="Area of work" width={550} imageUrl={computer}>
        <Choose>
          <When condition={container.loading}>
            <SkeletonRolePreview />
          </When>
          <Otherwise>
            <AreaRolesForm
              primaryRoles={container.primaryRoles}
              yearsExperienceList={container.yearsExperienceList}
              addBlankJobExperienceItem={container.addBlankJobExperienceItem}
              hasJobExperiences={container.hasJobExperiences}
              hasSubmittedJobExperiences={container.hasSubmittedJobExperiences}
              loadingCandidate={container.loadingCandidate}
              initialValues={container.initialAreaFormValues}
              submitOpenForms={container.submitOpenForms}
              submitJobExperience={container.submitJobExperience}
              currentlyEditingJobExperience={container.currentlyEditingJobExperience}>
              <For each="role" of={container.jobExperiencesList}>
                <Choose>
                  <When condition={role.editing}>
                    <RoleForm
                      form={role.formName}
                      isNew={role.isNew}
                      initialValues={{
                        job_role_id: role.job_role_id,
                        years_experience: role.years_experience,
                        id: role.id,
                      }}
                      name={role.name}
                      rolesList={container.rolesList}
                      yearsExperienceList={container.yearsExperienceList}
                      createJobExperience={container.createJobExperience}
                      updateJobExperience={container.updateJobExperience}
                      toggleJobExperienceEdit={() => container.toggleJobExperienceEdit(role.id, false)}
                      deleteBlankJobExperienceItem={() => container.deleteBlankJobExperienceItem(role.tempId)}
                      key={role.formName}
                    />
                  </When>
                  <Otherwise>
                    <RolePreview
                      name={role.name}
                      yearsExperience={role.years_experience}
                      toggleJobExperienceEdit={() => container.toggleJobExperienceEdit(role.id, true)}
                      deleteJobExperience={() => container.deleteJobExperience(role.id)}
                      id={`role-${role.id}`}
                      key={role.id}
                    />
                  </Otherwise>
                </Choose>
              </For>
            </AreaRolesForm>
          </Otherwise>
        </Choose>
      </Card>
    )}
  </AreaRoles>
)

export default AreaRolesScene
